import React from "react";
import DashboardLeadTabel from "./DashboardLeadTabel";
import DashboardSmallCard from "./DashboardSmallCard";
import { useNavigate } from "react-router-dom";
const LeadCountCard = ({ count }) => {
  const navigate=useNavigate()
  const handleClick = () => {
    navigate('enquireform')
  };
  return (
    <div className="flex  justify-between gap-4">
      <div className="w-1/2 h-40">
        <DashboardSmallCard
          title="Total Enquiries"
          para={count}
          buttonStatus={true}
          buttonname="View Enquiries"
          onClick={handleClick}
        />
      </div>
      <div className="w-1/2">
        <DashboardLeadTabel />
      </div>
    </div>
  );
};

export default LeadCountCard;
